/*
  © 2024 KondaSoft
  https://www.kondasoft.com
*/

class KsFancySlideshow extends HTMLElement {
  constructor () {
    super()

    this.initSwiper()
    this.animateOnScroll()
  }

  initSwiper () {
    const sliderElem = this.querySelector('.swiper')

    const navigation = {
      enabled: sliderElem.dataset.swiperNavigation === 'true',
      prevEl: '.swiper-button-prev',
      nextEl: '.swiper-button-next' 
    }
  
    const pagination = {
      enabled: sliderElem.dataset.swiperPagination === 'bullets' || sliderElem.dataset.swiperPagination === 'fraction',
      el: '.swiper-pagination',
      type: sliderElem.dataset.swiperPagination,
      dynamicBullets: false,
      dynamicMainBullets: 2,
      renderFraction: function (currentClass, totalClass) {
        return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
      }
    }

    const effect = sliderElem.dataset.swiperEffect
  
    const scrollbar = {
      enabled: sliderElem.dataset.swiperPagination === 'scrollbar',
      el: sliderElem.querySelector('.swiper-scrollbar'),
      draggable: true
    }
  
    const speed = Number(sliderElem.dataset.swiperSpeed || 300)
  
    const autoplay = sliderElem.dataset.swiperAutoplay === '0'
      ? undefined
      : { delay: Number(sliderElem.dataset.swiperAutoplay) * 1000 }

    const creativeEffect = {
      prev: { translate: [0, 0, -400],},
      next: { translate: ['100%', 0, 0]},
    }

    const breakpoints = {
      0: {
        slidesPerView: sliderElem.dataset.swiperPartial === 'true' ? 1.4 : 1,
        spaceBetween: sliderElem.dataset.swiperSpacing === 'true' ? Number(sliderElem.dataset.swiperSpacingMobile) : 0
      },
      750: {
        slidesPerView: sliderElem.dataset.swiperPartial === 'true' ? 1.3 : 1,
        spaceBetween: sliderElem.dataset.swiperSpacing === 'true' ? Number(sliderElem.dataset.swiperSpacingDesktop) : 0
      },
      990: {
        slidesPerView: sliderElem.dataset.swiperPartial === 'true' ? 1.2 : 1,
        spaceBetween: sliderElem.dataset.swiperSpacing === 'true' ? Number(sliderElem.dataset.swiperSpacingDesktop) : 0
      }
    }

    this.slider = new window.Swiper(sliderElem, {
      navigation,
      pagination,
      scrollbar,
      effect,
      speed,
      autoplay,
      creativeEffect,
      breakpoints,
      centeredSlides: true,
      loop: true,
      watchSlidesProgress: true,
      fadeEffect: { crossFade: true },
      mousewheel: { enabled: true, forceToAxis: true },
      on: {
      }
    })
  }

  animateOnScroll () {
    window.addEventListener('scroll', () => {
      const windowHeight = window.innerHeight
      const sectionHeight = this.clientHeight

      const top = Math.round(this.getBoundingClientRect().top)
      const bottom = Math.round(this.getBoundingClientRect().bottom)
      const visibilityTop = Math.round((windowHeight - top) / sectionHeight * 100)
      const visibilityBottom = Math.round(bottom / sectionHeight * 100)

      if (visibilityTop > 0 && visibilityTop < 100) {
        this.querySelectorAll('.ks-media-wrapper').forEach(elem => {
          const overlayOpacity = Number(elem.dataset.overlayOpacity)
          const final = Math.round((100 - overlayOpacity) * (1 - visibilityTop / 100) + overlayOpacity)
          elem.style.setProperty('--overlay-opacity', final + '%')
        })
      } else if (visibilityBottom > 0 && visibilityBottom < 100) {
        this.querySelectorAll('.ks-media-wrapper').forEach(elem => {
          const overlayOpacity = Number(elem.dataset.overlayOpacity)
          const final = Math.round((100 - overlayOpacity) * (1 - visibilityBottom / 100) + overlayOpacity)
          elem.style.setProperty('--overlay-opacity', final + '%')
        })
      }
    })
  }
}
customElements.define('ks-fancy-slideshow', KsFancySlideshow)

class KsParallaxMedia extends HTMLElement {
  constructor () {
    super()

    this.animateOnScroll()

    const script = document.querySelector('script[src*="vendor-simple-parallax"]')
    script.onload = () => {
      this.init()
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (event.detail.sectionId === this.dataset.sectionId) {
        this.init()
      }
    })
  }

  init () {
    new window.simpleParallax(this.querySelectorAll('.ks-parallax-media-media'), {
      orientation: this.dataset.parallaxOrientation,
      scale: Number(this.dataset.parallaxScale)
    })
  }

  animateOnScroll () {
    window.addEventListener('scroll', () => {
      const windowHeight = window.innerHeight
      const sectionHeight = this.clientHeight

      const top = Math.round(this.getBoundingClientRect().top)
      const bottom = Math.round(this.getBoundingClientRect().bottom)
      const visibilityTop = Math.round((windowHeight - top) / sectionHeight * 100)
      const visibilityBottom = Math.round(bottom / sectionHeight * 100)

      if (visibilityTop > 0 && visibilityTop < 100) {
        this.querySelectorAll('.ks-media-wrapper').forEach(elem => {
          const overlayOpacity = Number(elem.dataset.overlayOpacity)
          const final = Math.round((100 - overlayOpacity) * (1 - visibilityTop / 100) + overlayOpacity)
          elem.style.setProperty('--overlay-opacity', final + '%')
        })
      } else if (visibilityBottom > 0 && visibilityBottom < 100) {
        this.querySelectorAll('.ks-media-wrapper').forEach(elem => {
          const overlayOpacity = Number(elem.dataset.overlayOpacity)
          const final = Math.round((100 - overlayOpacity) * (1 - visibilityBottom / 100) + overlayOpacity)
          elem.style.setProperty('--overlay-opacity', final + '%')
        })
      }
    })
  }
}
customElements.define('ks-parallax-media', KsParallaxMedia)

class KsStickyMedia extends HTMLElement {
  constructor () {
    super()

    this.animateOnScroll()
  }

  animateOnScroll () {
    window.addEventListener('scroll', () => {
      const windowHeight = window.innerHeight

      const top = this.getBoundingClientRect().top
      const bottom = this.getBoundingClientRect().bottom
      const visibilityTop = Math.round(top / windowHeight * 100)
      const visibilityBottom = Math.round(bottom / windowHeight * 100)

      if (visibilityTop > 0 && visibilityTop < 100) {
        this.querySelectorAll('.ks-media-wrapper').forEach(elem => {
          const overlayOpacity = Number(elem.dataset.overlayOpacity)
          const final = Math.round((100 - overlayOpacity) * visibilityTop / 100 + overlayOpacity)
          elem.style.setProperty('--overlay-opacity', final + '%')
        })
      } else if (visibilityBottom > 0 && visibilityBottom < 100) {
        this.querySelectorAll('.ks-media-wrapper').forEach(elem => {
          const overlayOpacity = Number(elem.dataset.overlayOpacity)
          const final = Math.round((100 - overlayOpacity) * (1 - visibilityBottom / 100) + overlayOpacity)
          elem.style.setProperty('--overlay-opacity', final + '%')
        })
      }
    })
  }
}
customElements.define('ks-sticky-media', KsStickyMedia)

class KsMarquee extends HTMLElement {
  constructor () {
    super()

    this.init()

    document.addEventListener('shopify:section:load', (event) => {
      if (event.detail.sectionId === this.dataset.sectionId) {
        this.init()
      }
    })
  }

  init () {
    const list = this.querySelector('.ks-marquee-list')
    list.querySelectorAll('.ks-marquee-item[aria-hidden="true"]').forEach(elem => elem.remove())

    const marqueeWidth = list.scrollWidth
    const marqueeLength = list.querySelectorAll('li').length

    list.insertAdjacentHTML('beforeEnd', list.innerHTML)
    list.insertAdjacentHTML('beforeEnd', list.innerHTML)

    list.querySelectorAll('.ks-marquee-item').forEach((item, index) => {
      if (index >= marqueeLength) {
        item.setAttribute('aria-hidden', 'true')
      }
    })

    let style = `
      <style>
        #ks-marquee-${this.dataset.marqueeId} .ks-marquee-list {
          animation-name: ks_marquee_animation_${this.dataset.marqueeId};
          animation-duration: ${this.dataset.marqueeDuration}s;
        }
        @keyframes ks_marquee_animation_${this.dataset.marqueeId} {
          to { transform: translateX(-${marqueeWidth}px); }
        }
      </style>
    `
    if (this.dataset.marqueeDirection === 'right') {
      style += `
        <style>
          @keyframes ks_marquee_animation_${this.dataset.marqueeId} {
            from { transform: translateX(-${marqueeWidth}px); }    
            to { transform: 0); }    
          }
        </style>
      `
    }

    this.insertAdjacentHTML('beforeBegin', style)
  }
}
customElements.define('ks-marquee', KsMarquee)

class KsShoppableVideos extends HTMLElement {
  constructor () {
    super()

    this.querySelectorAll('video').forEach(video => {
      video.addEventListener('click', () => {
        this.onVideoPlay(video)
      })
    })

    this.querySelectorAll('a[data-quick-view]').forEach(link => {
      link.addEventListener('click', (event) => {
        event.preventDefault()
        this.openQuickView(link)
      })
    })

    this.querySelector('.slider').addEventListener("scroll", () => {
      this.querySelectorAll('video').forEach(video => {
        video.closest('.card').setAttribute('data-playing', 'false')
        video.pause()
      })
    })
  }

  onVideoPlay (video) {
    this.querySelectorAll('video').forEach(elem => {
      if (elem.dataset.index !== video.dataset.index) {
        elem.closest('.card').setAttribute('data-playing', 'false')
        elem.pause()
      }
    })

    const card = video.closest('.card')

    if (card.dataset.playing === 'true') {
      video.closest('.card').setAttribute('data-playing', 'false')
      video.pause()
    } else {
      video.closest('.card').setAttribute('data-playing', 'true')
      video.muted = false
      video.play()
    }
  }

  async openQuickView (link) {
    link.disabled = true
    link.setAttribute('aria-busy', 'true')
    link.querySelector('.icon-wrapper').setAttribute('hidden', 'hidden')
    link.querySelector('.spinner-border').removeAttribute('hidden')

    const response = await fetch(link.dataset.productUrl + '.js')

    if (response.ok) {
      const data = await response.json()
      console.log(data)

      document.querySelector('product-quick-view-modal').showModal(data)
    }

    link.disabled = false
    link.removeAttribute('aria-busy')
    link.querySelector('.icon-wrapper').removeAttribute('hidden')
    link.querySelector('.spinner-border').setAttribute('hidden', 'hidden')
  }
}
customElements.define('ks-shoppable-videos', KsShoppableVideos)

class KsImageCompare extends HTMLElement {
  constructor () {
    super()

    const script = document.querySelector('script[src*="vendor-image-compare"]')
    script.onload = () => {
      this.init()
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (event.detail.sectionId === this.dataset.sectionId) {
        this.init()
      }
    })
  }

  init () {
    this.querySelectorAll('[data-image-compare]').forEach(elem => {
      new window.ImageCompare(elem, {
        controlColor: this.dataset.icvControlsColor,
        controlShadow: true,
        addCircle: this.dataset.icvControlsCircle === 'true',
        addCircleBlur: true,
        showLabels: this.dataset.icvShowLabels === 'true',
        labelOptions: {
          before: this.dataset.icvLabelBefore,
          after: this.dataset.icvLabelAfter,
          onHover: false
        },
        smoothing: this.dataset.icvSmoothing === 'true',
        smoothingAmount: 100,
        hoverStart: this.dataset.icvHoverStart === 'true',
        verticalMode: this.dataset.icvVerticalMode === 'true',
        startingPoint: Number(this.dataset.icvStartingPoint),
        fluidMode: false
      }).mount()
    })
  }
}
customElements.define('ks-image-compare', KsImageCompare)

class KsInstagramGallery extends HTMLElement {
  constructor () {
    super()

    this.gallery = new window.Swiper(this, {
      speed: Number(this.dataset.sliderSpeed),
      spaceBetween: 12,
      centeredSlides: true,
      autoplay: this.autoplay,
      loop: true,
      navigation: {
        prevEl: '.swiper-button-prev',
        nextEl: '.swiper-button-next'
      },
      mousewheel: {
        enabled: true,
        forceToAxis: true
      },
      breakpoints: {
        0: {
          slidesPerView: 1.4,
          spaceBetween: this.spacingMobile
        },
        600: { 
          slidesPerView: 2,
          spaceBetween: this.spacingMobile
        },
        900: {
          slidesPerView: 3,
          spaceBetween: this.spacingMobile
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: this.spacingDesktop
        },
        1500: {
          slidesPerView: 5,
          spaceBetween: this.spacingDesktop
        },
        1800: {
          slidesPerView: 6,
          spaceBetween: this.spacingDesktop
        }
      }
    })
  }

  spacingMobile = this.dataset.swiperSpacing === 'true' ? Number(this.dataset.swiperSpacingMobile) : 0
  spacingDesktop = this.dataset.swiperSpacing === 'true' ? Number(this.dataset.swiperSpacingDesktop) : 0

  autoplay = this.dataset.sliderAutoplay === '0'
    ? undefined
    : { delay: Number(this.dataset.sliderAutoplay) * 1000, pauseOnMouseEnter: true }
}
customElements.define('ks-instagram-gallery', KsInstagramGallery)

class KsNewsletterPopup extends HTMLElement {
  constructor () {
    super()

    if (window.Shopify.designMode) return

    if (window.location.href.includes('newsletter-popup')) {
      this.open()
      return
    }

    if (document.cookie.indexOf('ks-newsletter-popup') > -1) {
      return
    };

    (async () => {
      await new Promise(resolve => setTimeout(resolve, Number(this.dataset.configDelay) * 1000))
      window.ksCreateCookie('ks-newsletter-popup', true, Number(this.dataset.configDaysToWait))
      this.open()
    })()
  }

  onBodyClick(event) {
    if (event.target.classList.contains('ks-dawn-modal')) {
      this.close(false);
    } 
  }

  open() {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden')
    this.querySelector('.ks-dawn-modal-toggler').addEventListener('click', this.close.bind(this))
    window.trapFocus(this.querySelector('[tabindex="-1"]'))
  }

  close() {
    this.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent)
    document.body.classList.remove('overflow-hidden')
    window.removeTrapFocus()
  }
}
customElements.define('ks-newsletter-popup', KsNewsletterPopup)

class KsLookBook extends HTMLElement {
  constructor () {
    super()

    this.injectVendorScripts()
    this.querySelectorAll('.ks-lookbook-point-list-item').forEach((elem) => {
      this.handleTooltip(elem)
    })
  } 
  
  async injectVendorScripts () {
    if (!window.FloatingUICore) {
      const script = document.createElement('script')
      script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.8')
      document.head.appendChild(script) 
    }
    if (!window.FloatingUIDOM) {
      await new Promise(r => setTimeout(r, 500))

      const script = document.createElement('script')
      script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.8')
      document.head.appendChild(script)
    }
  }

  handleTooltip(elem) {
    const btn = elem.querySelector('button')
    const tooltip = elem.querySelector('.ks-tooltip')

    function update() {
      window.FloatingUIDOM.computePosition(btn, tooltip, {
        middleware: [
          window.FloatingUIDOM.offset(0),
          window.FloatingUIDOM.autoPlacement()
        ],
      }).then(({x, y}) => {
        Object.assign(tooltip.style, {
          left: `${x}px`,
          top: `${y}px`,
        })
      })
    }

    function showTooltip() {
      tooltip.classList.add('show')
      update()
    }
    
    function hideTooltip() {
      setTimeout(() => {
        tooltip.classList.remove('show')
        tooltip.classList.add('hiding')
        setTimeout(() => {
          tooltip.classList.remove('hiding')
        }, 200)
      }, 100)
    }
    
    if (window.matchMedia("(pointer: coarse)").matches) {
      [
        ['mouseenter', showTooltip],
        ['mouseleave', hideTooltip],
        ['focus', showTooltip],
        ['blur', hideTooltip],
      ].forEach(([event, listener]) => {
        btn.addEventListener(event, listener)
      })
    } else {
      [
        ['focus', showTooltip],
        ['blur', hideTooltip],
      ].forEach(([event, listener]) => {
        btn.addEventListener(event, listener)
      })
    }
  }
}
customElements.define('ks-lookbook', KsLookBook)

class KsSimpleCollections extends HTMLElement {
  constructor () {
    super()

    if (window.matchMedia('(max-width: 749px)').matches) {
      setTimeout(() => {
        const left = this.querySelector('.ks-simple-collections-list-item.active')?.getBoundingClientRect().left || 0
        console.log(left)
        this.querySelector('.ks-simple-collections-list').scrollBy({ left, behavior: 'smooth' })
      }, 1000)
    }
  }
}
customElements.define('ks-simple-collections', KsSimpleCollections)


class KsCrossSells extends HTMLElement {
  // NOTE: all wiring happens in connectedCallback (deferred by one frame),
  // NOT in the constructor. Apps like Teeinblue re-render the product area
  // after load, and during that upgrade the constructor runs before the
  // element's children are parsed - listeners attached there go nowhere.
  //
  // Wiring is tracked per element via a JS property (__ksWired) instead of
  // a data attribute: apps that clone DOM copy attributes but not
  // listeners, so a property marker lets the poll detect clones and rewire.
  init () {
    this.wireAll()
  }

  wireAll () {
    this.querySelectorAll('input[type="checkbox"').forEach(checkbox => {
      if (checkbox.__ksWired) return
      checkbox.__ksWired = true
      checkbox.addEventListener('change', () => this.onCheckboxChange(checkbox))
    })

    this.querySelectorAll('select[name="variant-id"').forEach(select => {
      if (select.__ksWired) return
      select.__ksWired = true
      // Shield cross-sell selects from app scripts (e.g. Teeinblue):
      // bubble-phase document listeners can otherwise block the dropdown
      // from opening or revert the customer's choice
      const shieldEvents = ['mousedown', 'touchstart', 'click', 'keydown']
      shieldEvents.forEach(evtName => {
        select.addEventListener(evtName, (event) => event.stopPropagation())
      })
      select.addEventListener('change', (event) => {
        event.stopPropagation()
        this.onChangeVariant(select)
      })
    })

    this.querySelectorAll('[data-cross-sells-footer] .button').forEach(btn => {
      if (btn.__ksWired) return
      btn.__ksWired = true
      btn.addEventListener('click', () => this.addToCart(btn))
    })
  }

  connectedCallback () {
    // Defer one frame so children are parsed even when the element is
    // (re)inserted dynamically by the theme editor or app scripts
    requestAnimationFrame(() => {
      this.init()
      this.setupMainFormSync()
      this.startPolling()
      if (this.dataset.discountEnabled === 'true' || this.querySelector('[data-sync-with-main]')) {
        this.updateTotalPrice()
      }
    })
  }

  startPolling () {
    if (this.mainFormSyncInterval) return
    if (!this.querySelector('[data-sync-with-main]')) return

    // Fallback: customizer apps may swap the variant silently without
    // events, and DOM cloned by apps loses listeners - rewire as needed
    this.mainFormSyncInterval = setInterval(() => {
      this.syncCurrentProductVariant()
      this.guardSelects()
      this.wireAll()
    }, 800)
  }

  // For customizer products (e.g. Teeinblue) the current product row has no
  // select of its own - it follows the variant selected on the main form.
  setupMainFormSync () {
    const syncInput = this.querySelector('[name="variant-id"][data-sync-with-main]')
    if (!syncInput || this.mainFormSyncReady) return
    this.mainFormSyncReady = true

    const mapScript = syncInput.closest('[data-cross-sells-list-item]').querySelector('[data-variant-map]')
    try {
      this.variantMap = mapScript ? JSON.parse(mapScript.textContent) : {}
    } catch (e) {
      this.variantMap = {}
    }

    this.syncCurrentProductVariant()

    // Theme pickers update [name="id"] after an async section re-render,
    // so re-check shortly after any change event
    document.addEventListener('change', () => {
      setTimeout(() => this.syncCurrentProductVariant(), 500)
    })

    // Theme pub/sub fires once the variant change has been applied
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, () => {
        setTimeout(() => this.syncCurrentProductVariant(), 100)
      })
    }
  }

  // Re-enable cross-sell selects if an app script disabled them
  guardSelects () {
    this.querySelectorAll('select[name="variant-id"][disabled]').forEach(select => {
      select.disabled = false
    })
  }

  disconnectedCallback () {
    if (this.mainFormSyncInterval) {
      clearInterval(this.mainFormSyncInterval)
      this.mainFormSyncInterval = null
    }
  }

  syncCurrentProductVariant () {
    const syncEl = this.querySelector('[name="variant-id"][data-sync-with-main]')
    if (!syncEl) return

    const isSelect = syncEl.tagName === 'SELECT'
    const knowsVariant = (id) => {
      if (!id) return false
      if (isSelect) return !!syncEl.querySelector('option[value="' + id + '"]')
      return !!(this.variantMap || {})[id]
    }

    let variantId = null

    // Customizer app pickers (e.g. Teeinblue) update the URL param but not
    // always the theme form input, so the URL is the primary signal
    const urlVariant = new URLSearchParams(window.location.search).get('variant')
    if (knowsVariant(urlVariant)) variantId = urlVariant

    if (!variantId) {
      const mainForm = document.getElementById(syncEl.dataset.mainFormId)
      let idInput = mainForm ? mainForm.querySelector('[name="id"]') : null
      if (!idInput) {
        // Fallback: first real product form on the page
        idInput = document.querySelector('form[action*="/cart/add"][id^="product-form-"] input[name="id"]') ||
          document.querySelector('form[action*="/cart/add"] input[name="id"]')
      }
      if (idInput && knowsVariant(idInput.value)) variantId = idInput.value
    }

    if (!variantId || syncEl.value === variantId) return

    syncEl.value = variantId
    if (isSelect) {
      // Updates the item image and totals from the selected option
      this.onChangeVariant(syncEl)
    } else {
      const variantData = (this.variantMap || {})[variantId]
      if (variantData) {
        syncEl.dataset.price = variantData.price
        syncEl.dataset.compareAtPrice = variantData.compare || ''
      }
      this.updateTotalPrice()
    }
  }

  getSelectedCount () {
    let count = 0
    this.querySelectorAll('input[type="checkbox"').forEach(checkbox => {
      if (checkbox.checked) count++
    })
    return count
  }

  getBundleDiscount (totalPrice) {
    if (this.dataset.discountEnabled !== 'true') return 0

    const minItems = Number(this.dataset.discountMinItems || 2)
    const value = Number(this.dataset.discountValue || 0)

    if (!value || totalPrice <= 0 || this.getSelectedCount() < minItems) return 0

    let discount
    if (this.dataset.discountType === 'fixed') {
      discount = Math.round(value * 100)
    } else {
      discount = Math.round(totalPrice * value / 100)
    }
    return Math.min(discount, totalPrice)
  }

  onChangeVariant (select) {
    const variantImage = (select[select.selectedIndex].dataset.variantImage || '').trim()

    if (variantImage.length) {
      const img = select.closest('[data-cross-sells-list-item]').querySelector('.img-wrapper img')
      if (img) {
        const prevSrc = img.getAttribute('src')
        img.onerror = () => {
          img.onerror = null
          img.setAttribute('src', prevSrc)
        }
        img.setAttribute('src', variantImage)
      }
    }

    this.updateTotalPrice()
  }

  onCheckboxChange (checkbox) {
    if (checkbox.checked) {
      checkbox.closest('[data-cross-sells-list-item]').setAttribute('data-is-selected', 'true')
    } else {
      checkbox.closest('[data-cross-sells-list-item]').setAttribute('data-is-selected', 'false')
    }
    this.updateTotalPrice()
  }

  updateTotalPrice () {
    let totalPrice = 0
    let totalComparePrice = 0

    this.querySelectorAll('input[type="checkbox"').forEach(checkbox => {
      if (checkbox.checked) {
        const inputHidden = checkbox.closest('[data-cross-sells-list-item]').querySelector('input[name="variant-id"][type="hidden"]')
        if (inputHidden) {
          totalPrice += Number(inputHidden.dataset.price)
          totalComparePrice += Number(inputHidden.dataset.compareAtPrice)
        }

        const select = checkbox.closest('[data-cross-sells-list-item]').querySelector('select[name="variant-id"]')
        if (select) {
          totalPrice += Number(select[select.selectedIndex].dataset.price)
          totalComparePrice += Number(select[select.selectedIndex].dataset.compareAtPrice)
        }
      }
    })

    const bundleDiscount = this.getBundleDiscount(totalPrice)
    const finalPrice = totalPrice - bundleDiscount
    const comparePrice = Math.max(totalComparePrice, totalPrice)

    this.querySelectorAll('[data-total-price]').forEach(elem => {
      elem.textContent = `${window.Shopify.formatMoney(finalPrice)}`.replace('.00', '')
    })

    this.querySelectorAll('[data-total-compare-price]').forEach(elem => {
      elem.textContent = `${window.Shopify.formatMoney(comparePrice)}`.replace('.00', '')
    })

    this.querySelectorAll('[data-total-savings]').forEach(elem => {
      elem.textContent = `${window.Shopify.formatMoney(comparePrice - finalPrice)}`.replace('.00', '')
    })

    this.querySelectorAll('[data-bundle-discount-row]').forEach(elem => {
      if (bundleDiscount > 0) {
        elem.removeAttribute('hidden')
        elem.querySelector('[data-bundle-discount-amount]').textContent = `-${window.Shopify.formatMoney(bundleDiscount)}`.replace('.00', '')
      } else {
        elem.setAttribute('hidden', 'hidden')
      }
    })

    if (totalPrice === 0) {
      this.querySelector('[data-cross-sells-footer] .button').disabled = true
    } else {
      this.querySelector('[data-cross-sells-footer] .button').disabled = false
    }

    if (comparePrice > finalPrice) {
      this.querySelectorAll('[data-total-compare-price]').forEach(elem => {
        elem.closest('s').removeAttribute('hidden')
      })
      this.querySelectorAll('[data-total-savings]').forEach(elem => {
        elem.parentElement.removeAttribute('hidden')
      })
    } else {
      this.querySelectorAll('[data-total-compare-price]').forEach(elem => {
        elem.closest('s').setAttribute('hidden', 'hidden')
      })
      this.querySelectorAll('[data-total-savings]').forEach(elem => {
        elem.parentElement.setAttribute('hidden', 'hidden')
      })
    }
  }

  // Collect properties[...] values from the main product form so FBT adds
  // the current product WITH the personalization the customer entered
  getMainFormProperties () {
    const mainForm = this.getMainForm()
    if (!mainForm) return null

    const properties = {}
    let hasProperties = false
    new FormData(mainForm).forEach((value, key) => {
      if (typeof value !== 'string') return
      const match = key.match(/^properties\[(.+)\]$/)
      if (match && value.trim() !== '') {
        properties[match[1]] = value
        hasProperties = true
      }
    })
    return hasProperties ? properties : null
  }

  getMainForm () {
    const syncEl = this.querySelector('[data-sync-with-main]')
    return (syncEl && document.getElementById(syncEl.dataset.mainFormId)) ||
      document.querySelector('form[action*="/cart/add"][id^="product-form-"]')
  }

  async addToCart (atcBtn) {
    this.syncCurrentProductVariant()

    atcBtn.classList.add('loading')
    atcBtn.disabled = true
    atcBtn.setAttribute('aria-busy', 'true')
    atcBtn.querySelector('.loading__spinner').classList.remove('hidden')

    const items = []
    let triggerMainAtc = false

    this.querySelectorAll('input[type="checkbox"').forEach(checkbox => {
      if (checkbox.checked) {
        const listItem = checkbox.closest('[data-cross-sells-list-item]')
        const syncEl = listItem.querySelector('[data-sync-with-main]')

        // On customizer pages (Teeinblue) the current product must go
        // through the main Add To Cart so the app attaches its design
        // data - a plain cart/add.js call would lose the personalization
        if (syncEl && syncEl.tagName === 'INPUT') {
          triggerMainAtc = true
          return
        }

        const id = Number(listItem.querySelector('[name="variant-id"]').value)
        const item = { id, quantity: 1 }

        // Current product (regular pages): carry the personalization the
        // customer filled in on the main form into the line item
        if (syncEl) {
          const properties = this.getMainFormProperties()
          if (properties) item.properties = properties
        }

        items.push(item)
      }
    })

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer')

    // Add the customizer current product FIRST and wait until the app
    // confirms it is in the cart, so the drawer opens once with the
    // complete bundle instead of the app product popping in later
    if (triggerMainAtc) {
      if (window.teeinblue && typeof window.teeinblue.addToCart === 'function') {
        await new Promise((resolve) => {
          let settled = false
          const done = () => {
            if (settled) return
            settled = true
            document.removeEventListener('teeinblue-event-after-cart-added', done)
            clearTimeout(timer)
            resolve()
          }
          const timer = setTimeout(done, 8000)
          document.addEventListener('teeinblue-event-after-cart-added', done)
          try {
            // Official Teeinblue API - runs the app's full pipeline incl.
            // validation, design generation and personalization properties
            window.teeinblue.addToCart()
          } catch (e) {
            console.warn('KS Cross sells: teeinblue.addToCart failed', e)
            done()
          }
        })
      } else {
        // Fallback: press the main form's Add To Cart button
        const mainForm = this.getMainForm()
        const mainAtcBtn = mainForm ? mainForm.querySelector('button[name="add"], [type="submit"]') : null
        if (mainAtcBtn) mainAtcBtn.click()
      }
    }

    if (items.length) {
      const sections = cart.getSectionsToRender().map((section) => section.id)

      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items, sections })
      })
      const responseData = await response.json()

      cart.renderContents(responseData)
      if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty')
    }

    // Auto-apply the bundle discount code so it gets applied at checkout
    const discountUnlocked = this.dataset.discountEnabled === 'true' &&
      this.getSelectedCount() >= Number(this.dataset.discountMinItems || 2)

    if (this.dataset.discountCode && discountUnlocked) {
      try {
        await fetch(`${window.Shopify.routes.root}discount/${encodeURIComponent(this.dataset.discountCode)}`)
      } catch (e) {
        console.warn('KS Cross sells: could not apply discount code', e)
      }
    }

    atcBtn.style.width = ''
    atcBtn.classList.remove('loading')
    atcBtn.disabled = false
    atcBtn.setAttribute('aria-busy', 'false')
    atcBtn.querySelector('.loading__spinner').classList.add('hidden')
  }
}
// FBT custom dropdowns (customizer/Teeinblue pages) are driven entirely by
// document-level capture delegation: no per-element listeners means app
// re-renders, DOM cloning and bubble-phase interference can never kill them.
// The primary trigger is POINTERDOWN because some app scripts register
// earlier capture listeners that kill the click event entirely; click is
// kept as a fallback, with a debounce so one interaction toggles once.
if (!window.__ksFbtDdDelegated) {
  window.__ksFbtDdDelegated = true
  window.__ksFbtDdVersion = 13

  let lastFbtDdActionAt = 0

  // Open as a "portal": move the list to <body> with fixed positioning so
  // no ancestor overflow/transform/z-index (incl. app wrappers) can hide it
  const openFbtList = (toggle, dd, list) => {
    const rect = toggle.getBoundingClientRect()
    list.__ksHomeDd = dd || list.parentElement
    document.body.appendChild(list)
    list.style.position = 'fixed'
    list.style.top = (rect.bottom + 4) + 'px'
    list.style.left = rect.left + 'px'
    list.style.right = 'auto'
    list.style.width = rect.width + 'px'
    list.style.zIndex = '2147483647'
    list.hidden = false

    // App CSS force-hides our option buttons (display:none) - inline
    // !important styles outrank every stylesheet, so nothing can win
    list.style.setProperty('display', 'block', 'important')
    list.querySelectorAll('li').forEach(li => {
      li.removeAttribute('hidden')
      li.style.setProperty('display', 'block', 'important')
    })
    list.querySelectorAll('.ks-fbt-dd-option').forEach(opt => {
      opt.removeAttribute('hidden')
      opt.style.setProperty('display', 'block', 'important')
      opt.style.setProperty('visibility', 'visible', 'important')
      opt.style.setProperty('opacity', '1', 'important')
    })
  }

  const closeFbtList = (list) => {
    list.style.removeProperty('display')
    list.hidden = true
    if (list.__ksHomeDd && list.parentElement === document.body) {
      list.__ksHomeDd.appendChild(list)
    }
    const dd = list.closest('[data-fbt-dd]') || list.__ksHomeDd
    const ddToggle = dd ? dd.querySelector('.ks-fbt-dd-toggle') : null
    if (ddToggle) ddToggle.setAttribute('aria-expanded', 'false')
  }

  const closeAllFbtDd = (exceptList, target) => {
    document.querySelectorAll('.ks-fbt-dd-list').forEach(list => {
      if (list === exceptList || list.hidden) return
      // Presses inside the floating list (e.g. its scrollbar) don't close it
      if (target && list.contains(target)) return
      const dd = list.closest('[data-fbt-dd]') || list.__ksHomeDd
      if (target && dd && dd.contains(target)) return
      closeFbtList(list)
    })
  }

  // Close on page scroll/resize, but not when scrolling inside the list
  ;['scroll', 'resize'].forEach(evtName => {
    window.addEventListener(evtName, (event) => {
      if (event.target && event.target.closest && event.target.closest('.ks-fbt-dd-list')) return
      closeAllFbtDd(null, null)
    }, true)
  })

  const handleFbtDd = (event) => {
    const target = event.target
    if (!target || !target.closest) return

    const toggle = target.closest('.ks-fbt-dd-toggle')
    const option = target.closest('.ks-fbt-dd-option')

    if (!toggle && !option) {
      // Interaction elsewhere: close any open dropdown
      closeAllFbtDd(null, target)
      return
    }

    event.preventDefault()
    event.stopPropagation()

    // pointerdown handles the interaction; ignore the follow-up click
    const now = Date.now()
    if (now - lastFbtDdActionAt < 400) return
    lastFbtDdActionAt = now

    if (toggle) {
      // Resolve the list defensively - app scripts may strip wrappers
      // when they clone or re-render the DOM
      const dd = toggle.closest('[data-fbt-dd]')
      let list = dd ? dd.querySelector('.ks-fbt-dd-list') : null
      if (!list && dd) {
        // The open list is portaled to <body> - find it by its home link
        list = Array.prototype.find.call(
          document.querySelectorAll('body > .ks-fbt-dd-list'),
          l => l.__ksHomeDd === dd
        ) || null
      }
      if (!list && toggle.nextElementSibling && toggle.nextElementSibling.classList.contains('ks-fbt-dd-list')) {
        list = toggle.nextElementSibling
      }
      if (!list) {
        const container = toggle.closest('[data-cross-sells-list-item]') || toggle.parentElement
        list = container ? container.querySelector('.ks-fbt-dd-list') : null
      }
      if (!list) return
      closeAllFbtDd(list, null)
      if (list.hidden) {
        openFbtList(toggle, dd, list)
        toggle.setAttribute('aria-expanded', 'true')
      } else {
        closeFbtList(list)
      }
      return
    }

    if (option.disabled) return
    const optionList = option.closest('.ks-fbt-dd-list')
    const dd = option.closest('[data-fbt-dd]') || (optionList && optionList.__ksHomeDd)
    if (!dd) return
    const list = optionList || dd.querySelector('.ks-fbt-dd-list')
    const label = dd.querySelector('[data-fbt-dd-label]')
    const ddToggle = dd.querySelector('.ks-fbt-dd-toggle')
    const hiddenInput = dd.querySelector('input[name="variant-id"]')

    if (hiddenInput) {
      hiddenInput.value = option.dataset.variantId
      hiddenInput.dataset.price = option.dataset.price
      hiddenInput.dataset.compareAtPrice = option.dataset.compareAtPrice || ''
    }
    if (label) label.textContent = option.textContent.trim()
    // Clear the previous selection inside the (possibly portaled) list
    const optionScope = list || dd
    optionScope.querySelectorAll('.ks-fbt-dd-option[aria-selected]').forEach(opt => opt.removeAttribute('aria-selected'))
    option.setAttribute('aria-selected', 'true')

    const variantImageSrc = (option.dataset.variantImage || '').trim()
    const listItem = dd.closest('[data-cross-sells-list-item]')
    if (variantImageSrc && listItem) {
      const img = listItem.querySelector('.img-wrapper img')
      if (img) {
        // Restore the previous image if the variant image fails to load
        const prevSrc = img.getAttribute('src')
        img.onerror = () => {
          img.onerror = null
          img.setAttribute('src', prevSrc)
        }
        img.setAttribute('src', variantImageSrc)
      }
    }

    if (list) {
      closeFbtList(list)
    } else if (ddToggle) {
      ddToggle.setAttribute('aria-expanded', 'false')
    }

    const component = dd.closest('ks-cross-sells')
    if (component && component.updateTotalPrice) component.updateTotalPrice()
  }

  ;['pointerdown', 'click'].forEach(evtName => {
    // window capture runs BEFORE document capture, so even app scripts
    // that kill events at document level cannot get there first; the
    // debounce in the handler prevents double-toggling
    window.addEventListener(evtName, handleFbtDd, true)
    document.addEventListener(evtName, handleFbtDd, true)
  })
}

customElements.define('ks-cross-sells', KsCrossSells)